<template>
  <div class="animated fadeIn page-shell">
    <div class="page-main">
      <b-navbar :no-body="true" class="p-0 ml-auto" fixed :sticky="true" toggleable="lg" type="light" :variant="isDark ? 'dark' : 'light'">
        <b-navbar-brand>
            <i class="fa fa-shopping-cart bg-info p-3 font-2xl mr-3 float-left "></i>
            <div class="h5 text-primary mb-0 mt-2" style="padding-right: 150px !important;">
              CFOP - Cadastro / Edição
            </div>
            <div class="text-uppercase font-weight-bold font-xs" :class="isDark ? 'text-light' : 'text-muted'">
              {{registro.CONTADOR}} - {{registro.UTILIZACAO ? registro.UTILIZACAO.substring(0,22) : ""}}
            </div>
        </b-navbar-brand>
        <b-navbar-nav class="ml-auto p-0">
          <b-nav-item>
             <b-button  
                          variant="primary"  
                          ref="btGravar"
                          class="px-3"
                          @click="post()">
                <i class="fa fa-save"></i>  Gravar F10
            </b-button> 
            <b-button
              ref="btVoltar"
              variant="outline-info"
              class="px-3 mr-2"
              type="button"
              @click.stop.prevent="voltar()">
            
              <i class="fa fa-arrow-left"></i> <u>V</u>oltar
            </b-button>            
          </b-nav-item>
        </b-navbar-nav>
      
      </b-navbar>
        <b-row class="p-0">
          <b-col sm="12" >
            <b-card :bg-variant="isDark ? 'gray-700' : 'gray-100'">
              <div slot="header">
                <i class='fa fa-user-circle'></i> <strong>Identificação</strong>
              </div>   
              <b-row>
                <!--/.col-->
                <b-col sm="2">
                  <b-form-fieldset label="Código/ID">
                    <b-form-input type="text" id="codigo" :state="idValidador" :disabled="desabilitado" placeholder="Código" v-model="registro.CONTADOR"> </b-form-input>
                  </b-form-fieldset>
                </b-col>
                <!--/.col-->
                <b-col sm="4">
                  <b-form-fieldset label="Situação">
                    <b-form-select :plain="true"  v-model="registro.OP_SITUACAO" :options="options">
                    </b-form-select>
                  </b-form-fieldset>
                </b-col>
              </b-row>
              <b-row>
                <!--/.col-->
                <b-col sm="8">
                  <b-form-fieldset label="Descrição">
                    <b-form-input type="text" id="descricao" :state="utilizacaoValidador"  placeholder="Descricao" v-model="registro.UTILIZACAO"> </b-form-input>
                  </b-form-fieldset>
                </b-col>
              </b-row>
          </b-card>
        </b-col>
      </b-row>
      
     
    </div>
  </div>
</template>

<script>

import Tools from '@/tools/tools.js'

export default {
  data () {
    return {
      desabilitado: true,
      items: [],
      registro: {},
      isLoading: false,
      status: '',
      options: [
        { value: null, text: 'Informe a Situação' },
        { value: '0', text: 'Inativo' },
        { value: '1', text: 'Ativo' }
      ],
      submeteu: false
    }
  },
  components: {

  },
  methods: {
    voltar() {
      this.$router.push(`/cadastros/cfop/index`)
    },
    async post () {
      try {
        this.$store.commit('controle/setAguardando', true)
        if (!this.avisos()) {
          this.$store.commit('controle/setAguardando', false)
          await Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Prencha todos os dados obrigatórios!' )
          return
        }
        if ((this.$route.params.id === undefined )) {
          this.registro.CODIGO = this.registro.CONTADOR
          
          await this.$http.post(`/api/protected/cfop/post`, this.registro)
          await  this.$store.dispatch('cfop/GET_LISTA')
          this.$router.push(`/cadastros/cfop/index`)
        } else  {
          this.registro.NATUREZA = this.registro.UTILIZACAO
          await this.$http.post(`/api/protected/cfop/edit`, this.registro)
          await  this.$store.dispatch('cfop/GET_LISTA')
          this.$router.push(`/cadastros/cfop/index`)
        }
      } catch(erro) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Erro ao gravar o registro!' )
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    limparRegistro () {
      let registroVazio =
        {
          CONTADOR: null,
          DESCRICAO: null,
          OP_STATUS: '1'
        }
      this.registro = registroVazio
    },
    iniciarFormNovo () {
      this.registro.OP_SITUACAO = '1'
      this.desabilitado = false
    },
    iniciarFormEditar ( id ) {
      this.desabilitado = true
      let uri = `/api/protected/cfop/getById/${id}`
      
      this.$http.get(uri)
        .then((response) => {
          
          this.registro = response.data[0]
          if (this.registro.CONTADOR === '') {
            this.$bvToast.toast(`Falha ao executar a operação!!`, {
              title: 'Erro',
              autoHideDelay: 3000,
              variant: 'danger',
              appendToast: true
            })
            this.$router.replace('/cadastros/cfop/index') 
          }

        }), (error) => {
          this.$bvToast.toast(`Falha ao executar a operação!!`, {
              title: 'Erro',
              autoHideDelay: 3000,
              variant: 'danger',
              appendToast: true
            })
          this.$router.replace('/cadastros/cfop/index')
        }
    },
    prepararForm () {
    },
    avisos() {
      return this.utilizacaoValidador && this.idValidador
    }
  },
  created () {
    
    let id = this.$route.params.id
    this.prepararForm()
    if ( id ) {
      this.iniciarFormEditar( id )
    } else {
      this.iniciarFormNovo()
    }
  },
  computed:{
    isDark() {return this.$store.getters['tema/IS_DARK']  },
    utilizacaoValidador(){
      return ((this.registro.UTILIZACAO ) && (this.registro.UTILIZACAO.length > 2)) ? true : false
    },
    idValidador(){
      return ((this.registro.CONTADOR ) && (this.registro.CONTADOR > 0)) ? true : false
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/views/cadastros/cfop/CfopCadastro.vue